import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import { sedesPorInstitucionId } from "../../../../Services/Rest";
import Cookies from "universal-cookie";

function CreaInfraestructura(props) {
  const cookies = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);

  const [postSede, setPostSede] = useState("");
  const [postFechaInicial, setPostFechaInicial] = useState("");
  const [postNovedad, setPostNovedad] = useState("");
  const [postFechaInspeccion, setPostFechaInspeccion] = useState("");
  const [postNormas, setPostNormas] = useState("");
  const [postReforzamiento, setPostReforzamiento] = useState("");

  const [sedes, setSedes] = useState([]);

  // 🔹 cargar sedes
  useEffect(() => {
    axios
      .get(sedesPorInstitucionId + cookies.get("institucionid"))
      .then((res) => setSedes(res.data || []))
      .catch((err) => console.error(err));
  }, []);

  const postData = (e) => {
    e.preventDefault();

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaInfraestructura",
      data: {
        sede: postSede,
        fecha_Inicial: postFechaInicial,
        novedad: postNovedad,
        fecha_Inspeccion: postFechaInspeccion,
        cumplimiento_Normas: postNormas,
        reforzamiento: postReforzamiento,
        SolicitudId: props.idSolicitud,
      },
    })
      .then(() => {
        alert("Añadido con éxito");

        // 🔹 refrescar tabla
        props.onInfraestructuraCreada();

        // 🔹 limpiar
        setPostSede("");
        setPostFechaInicial("");
        setPostNovedad("");
        setPostFechaInspeccion("");
        setPostNormas("");
        setPostReforzamiento("");

        setIsOpen(false);
      })
      .catch((error) => {
        console.error(error);
        alert("Error al crear infraestructura");
      });
  };

  return (
    <div>
      <button className="btn btn-primary" onClick={() => setIsOpen(true)}>
        Nueva
      </button>

      <ReactModal isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)}>
        <div className="card shadow">
          <div className="card-header">
            <h6 className="font-weight-bold text-primary">
              Crear Infraestructura Física
            </h6>
          </div>

          <div className="card-body">
            <form onSubmit={postData}>
              <select
                className="form-control mb-2"
                value={postSede}
                onChange={(e) => setPostSede(e.target.value)}
                required
              >
                <option value="">Seleccione la sede</option>
                {sedes.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.nombre}
                  </option>
                ))}
                <option value="0">No tiene</option>
              </select>

              <label>Fecha inicial de construcción</label>
              <input
                type="date"
                className="form-control mb-2"
                value={postFechaInicial}
                onChange={(e) => setPostFechaInicial(e.target.value)}
              />

              <label>Fecha última inspección</label>
              <input
                type="date"
                className="form-control mb-2"
                value={postFechaInspeccion}
                onChange={(e) => setPostFechaInspeccion(e.target.value)}
              />

              <input
                className="form-control mb-2"
                placeholder="Novedad"
                value={postNovedad}
                onChange={(e) => setPostNovedad(e.target.value)}
              />

              <select
                className="form-control mb-2"
                value={postNormas}
                onChange={(e) => setPostNormas(e.target.value)}
                required
              >
                <option value="">¿Cumple normas de sismo resistencia?</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </select>

              <select
                className="form-control mb-3"
                value={postReforzamiento}
                onChange={(e) => setPostReforzamiento(e.target.value)}
                required
              >
                <option value="">¿Tiene reforzamiento estructural?</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </select>

              <button className="btn btn-primary btn-block" type="submit">
                Guardar
              </button>
            </form>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CreaInfraestructura;
